import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking (Counterparty to which the AIF has the greatest exposure)',
    isStatic: false
  },
  counterparty_exposure_flag: {
    isStatic: false,
    name: 'Counterparty exposure flag (Counterparty to which the AIF has the greatest exposure)'
  },
  counterparty_name: {
    name: 'Name of the counterparty to which the AIF has the greatest exposure',
    isStatic: false
  },
  counterparty_lei: {
    isStatic: false,
    name: 'LEI code of the counterparty to which the AIF has the greatest exposure'
  },
  counterparty_bic: {
    name: 'BIC code of the counterparty to which the AIF has the greatest exposure',
    isStatic: false
  },
  exposure_as_percentage_of_nav: {
    name: 'NAV percentage of the total exposure value of the counterparties to which the AIF has the greatest exposure',
    isStatic: false
  }
};

export function CountriesCPP({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.TOP_FIVE_COUNTRIES_EXPOSURE_EXCLUDE_CCP,
    onChangeFund,
    schema: schema.TOP_FIVE_COUNTRIES_EXPOSURE_EXCLUDE_CCP,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.TOP_FIVE_COUNTRIES_EXPOSURE_EXCLUDE_CCP
        ?.field_names || [],
    columnLables,
    order: 160,
    isMultiFunds,
    funds,
    tableName: 'TOP_FIVE_COUNTRIES_EXPOSURE_EXCLUDE_CCP'
  });

  return (
    <StyledTables id="reporttables-countries-cpp-group">
      {tables.map((rows, index) => (
        <Table
          key={index + 'TOP_FIVE_COUNTRIES_EXPOSURE_EXCLUDE_CCP'}
          id={`reporttables-countries-cpp-table-${index + 1}`}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        />
      ))}
    </StyledTables>
  );
}
